/* eslint-disable no-useless-catch */
import * as fetchService from '../../../sharedmodules/services/fetch';

export async function readNotification(getAccessToken) {

    const basePath = '/api';
    const endPoint = `${basePath}/notifications/collection`;

    const accessToken = await getAccessToken();

    const options = {
        headers: {
            Authorization: accessToken ? `Bearer ${accessToken}` : '',
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, options);
        return response.json();

    } catch (error) {

        throw (error);

    }

}
